import bulkDeleteRedditPostSubmissions from '@/graphql/mutations/posts/bulkDeleteRedditPostSubmissions.gql'
import deleteRedditPostSubmission from '@/graphql/mutations/posts/deleteRedditPostSubmission.gql'
import duplicateRedditPost from '@/graphql/mutations/posts/duplicateRedditPost.gql'
import submitRedditSubmission from '@/graphql/mutations/posts/submitRedditSubmission.gql'
import updateRedditPostSubmissionPostAt from '@/graphql/mutations/posts/updateRedditPostSubmissionPostAt.gql'
import allRedditSubmissions from '@/graphql/queries/posts/allRedditSubmissions.gql'

export default {
  code: 'reddit',
  name: 'Reddit',
  icon: 'reddit',
  color: '#ff4500',
  accountNoun: 'Account',
  postNoun: 'Post',
  internalPostNoun: 'Post',
  mutations: {
    submitPost: submitRedditSubmission,
    submitPostVariables: (submission) => {
      return {
        submissionId: submission.id,
        platform: submission.platform.toLowerCase()
      }
    },
    deletePost: deleteRedditPostSubmission,
    deletePostVariables: (submission) => {
      return { submissionId: submission.id }
    },
    bulkDeletePosts: bulkDeleteRedditPostSubmissions,
    bulkDeletePostsVariables: (submissions) => {
      return { submissionIds: submissions.map((s) => s.id) }
    },
    reschedulePost: updateRedditPostSubmissionPostAt,
    reschedulePostVariables: (submission) => {
      return { id: submission.id }
    },
    duplicatePost: duplicateRedditPost
  },
  queries: {
    allSubmissions: allRedditSubmissions
  }
}
